<template>
  <AppPagination
    :total="totalCount"
    :page-size="pageSize"
    :current-page="currentPage"
    class="tw-benchmark-pagination"
    @paging="onPaging"
  />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { AppPagination } from '@/client/components/_atoms'
import { type PropPageSizeType } from '@/client/components/_atoms/app_pagination/types'
import util from '@/client/core/util'
import { TrackingService } from '@/client/services'

import { useTwBenchmarkPostsStore } from '../../store/useTwBenchmarkPostsStore'

type PagingPayload = { pageSize: PropPageSizeType; currentPage: number }

/**
 * X 競合一覧のページネーション（AppPagination を PostsStore のページング state に接続する）。
 */
export default defineComponent({
  name: 'TwBenchmarkPagination',

  components: {
    AppPagination
  },

  setup() {
    const postsStore = useTwBenchmarkPostsStore()

    const onPaging = ({ pageSize, currentPage }: PagingPayload): void => {
      if (pageSize !== postsStore.pageSize) {
        TrackingService.sendEvent('select:競合キャンペーン分析|表示件数')
        void postsStore.setPageSize(pageSize)
      } else {
        const actionPaging =
          currentPage === postsStore.currentPage + 1
            ? '|次へ'
            : currentPage === postsStore.currentPage - 1
              ? '|前へ'
              : ''
        TrackingService.sendEvent(`click:競合キャンペーン分析|ページネーション${actionPaging}`)
        void postsStore.setPage(currentPage)
      }

      util.scrollToTop()
    }

    return {
      totalCount: computed(() => postsStore.totalCount),
      pageSize: computed(() => postsStore.pageSize),
      currentPage: computed(() => postsStore.currentPage),
      onPaging
    }
  }
})
</script>

<style lang="scss" scoped>
.tw-benchmark-pagination {
  justify-content: flex-end;
}
</style>
